import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import "./DeleteTrainingRequest.css";

function DeleteTrainingRequest() {
  const [request, setRequest] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  let { rid } = useParams();

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setRequest(response.data.request);
    }
    fetch();
    setIsLoading(false);
  }, [state.token, rid]);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/delete/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings/requests");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-training-request">
            <Col>
              <h4>
                {t("Capacitaciones.SolicitudesCapacitacion.EliminarTitulo")}
              </h4>
            </Col>
            <Col className="delete-training-request-form">
              <Col className="mb-1">
                <p>
                  {t(
                    "Capacitaciones.SolicitudesCapacitacion.ConfirmacionEliminar"
                  )}
                </p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Capacitaciones.SolicitudesCapacitacion.Eliminar")}
                </Button>
                <Button
                  className="danger"
                  onClick={() => navigate("/trainings/requests")}
                >
                  {t("Capacitaciones.SolicitudesCapacitacion.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteTrainingRequest;
